import * as React from 'react';
import { generateRoute } from '@js/common/helpers';
var LetteredList = function (_a) {
    var letter = _a.letter, brands = _a.brands;
    var brandsList = brands.map(function (brand) {
        return (React.createElement("a", { href: generateRoute('designer_details', { slug: brand.slug }), key: brand.slug },
            React.createElement("span", null, brand.name),
            (brand === null || brand === void 0 ? void 0 : brand.new_client) && React.createElement("span", { className: "badge" }, "NEW")));
    });
    return (React.createElement(React.Fragment, null,
        React.createElement("span", { className: "tagbook--directory-letter", id: letter }, letter),
        React.createElement("div", { className: "tagbook--directory-brands" }, brandsList)));
};
export { LetteredList };
